import { PointerEvent, useRef } from 'react';
import { CANVAS_HEIGHT, CANVAS_WIDTH, CashdeskBlock, MIN_BLOCK_SIZE, clamp } from './cashdeskBlocks';

interface PointerGesture {
  kind: 'move' | 'resize';
  blockId: string;
  startX: number;
  startY: number;
  origin: Pick<CashdeskBlock, 'x' | 'y' | 'width' | 'height'>;
}

const useTicketPointer = (blocks: CashdeskBlock[], onUpdateBlock: (id: string, patch: Partial<CashdeskBlock>) => void) => {
  const gestureRef = useRef<PointerGesture | null>(null);

  const start = (kind: PointerGesture['kind'], e: PointerEvent<HTMLDivElement>, block: CashdeskBlock) => {
    e.stopPropagation();
    gestureRef.current = { kind, blockId: block.id, startX: e.clientX, startY: e.clientY, origin: block };
    if (e.target instanceof Element) e.target.setPointerCapture(e.pointerId);
  };

  const onPointerMove = (e: PointerEvent<HTMLDivElement>) => {
    const gesture = gestureRef.current;
    if (!gesture) return;
    const block = blocks.find(b => b.id === gesture.blockId);
    if (!block) return;
    const dx = e.clientX - gesture.startX;
    const dy = e.clientY - gesture.startY;
    const { x, y, width, height } = gesture.origin;
    if (gesture.kind === 'resize') {
      onUpdateBlock(block.id, {
        width: clamp(width + dx, MIN_BLOCK_SIZE, CANVAS_WIDTH - block.x),
        height: clamp(height + dy, MIN_BLOCK_SIZE, CANVAS_HEIGHT - block.y),
      });
    } else {
      onUpdateBlock(block.id, {
        x: clamp(x + dx, 0, CANVAS_WIDTH - block.width),
        y: clamp(y + dy, 0, CANVAS_HEIGHT - block.height),
      });
    }
  };

  const onPointerUp = () => {
    gestureRef.current = null;
  };

  return { start, onPointerMove, onPointerUp };
};

export default useTicketPointer;
